var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSymbolWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2691 28.4833C17.134 29.1174 17.332 30.3524 16.5308 31.0652C15.5539 31.9343 14.3973 32.5904 13.134 32.9812C11.2483 33.5647 9.22487 33.5263 7.36262 32.8716C5.50037 32.217 3.89799 30.9809 2.7921 29.3458C1.6862 27.7107 1.13542 25.7634 1.22107 23.7913C1.30673 21.8192 2.02429 19.9269 3.26778 18.3939C4.51128 16.8608 6.21481 15.7683 8.1268 15.2776C10.0388 14.7869 12.0579 14.9241 13.886 15.6688C15.1106 16.1677 15.9731 16.8471 16.8709 17.7976C17.6073 18.5772 17.5358 19.8649 16.6192 20.4217C15.7026 20.9784 14.5214 20.6461 13.674 19.9887C13.2935 19.6935 12.8723 19.4495 12.4207 19.2655C11.3642 18.8351 10.1972 18.7558 9.09222 19.0394C7.9872 19.323 7.00266 19.9544 6.28399 20.8404C5.56532 21.7264 5.15061 22.82 5.10111 23.9598C5.0516 25.0996 5.36993 26.225 6.00907 27.17C6.64821 28.115 7.57429 28.8294 8.65057 29.2077C9.72684 29.5861 10.8962 29.6083 11.9861 29.2711C12.452 29.1269 12.8927 28.9204 13.2974 28.6593C14.1986 28.0778 15.4042 27.8492 16.2691 28.4833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7942 11.9089C13.263 7.80434 17.7811 5.66759 21.8857 7.13639C25.9903 8.60518 28.1271 13.1233 26.6583 17.2279C25.1895 21.3325 20.6714 23.4693 16.5668 22.0005C12.4622 20.5317 10.3254 16.0135 11.7942 11.9089ZM23.0103 15.9225C23.7581 13.8326 22.6702 11.5322 20.5803 10.7844C18.4905 10.0366 16.1901 11.1245 15.4422 13.2144C14.6944 15.3042 15.7823 17.6046 17.8722 18.3524C19.962 19.1003 22.2624 18.0124 23.0103 15.9225Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3232 15.1328C10.0381 14.9692 8.73176 15.0865 7.49471 15.4778C6.75162 15.7129 6.04494 16.0432 5.39159 16.4588C4.5515 16.9931 4.53854 18.153 5.23016 18.8692C5.92178 19.5853 7.05926 19.5695 7.96403 19.154C8.16441 19.0619 8.39288 19.1361 8.60421 19.0692C9.39134 18.8202 10.2833 18.7864 11.0989 18.914C11.8766 19.0357 12.7828 19.4397 13.4207 19.9673C12.3378 18.7223 11.451 16.7734 11.3232 15.1328Z",
    fill: "url(#paint0_linear_2211_8405)",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2022 20.563C21.9937 15.5566 27.5045 12.9504 32.5109 14.7419C37.5173 16.5334 40.1235 22.0442 38.332 27.0505C36.5405 32.0569 31.0297 34.6631 26.0233 32.8716C21.0169 31.0802 18.4108 25.5694 20.2022 20.563ZM34.4952 25.6776C35.5284 22.7902 34.0253 19.6119 31.1379 18.5787C28.2505 17.5455 25.0723 19.0486 24.039 21.936C23.0058 24.8233 24.5089 28.0016 27.3963 29.0348C30.2837 30.068 33.4619 28.565 34.4952 25.6776Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7052 16.7328C23.9481 15.6068 25.4636 14.821 27.0926 14.4507C27.0851 14.0184 27.0424 13.5864 26.9645 13.159C26.7764 12.1274 26.3871 11.1429 25.8186 10.2618C25.2501 9.38062 24.5136 8.62008 23.6512 8.02356L21.49 11.1481C21.9421 11.4608 22.3282 11.8595 22.6262 12.3214C22.9242 12.7833 23.1283 13.2994 23.2269 13.8402C23.3255 14.381 23.3166 14.936 23.2007 15.4733C23.1048 15.9179 22.9372 16.3432 22.7052 16.7328Z",
    fill: "url(#paint1_linear_2211_8405)",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7222 20.5471C23.2907 21.2514 21.4945 21.8771 19.8981 21.8642C19.7832 22.4245 19.7165 22.995 19.6995 23.5695C19.6606 24.8771 19.8797 26.1795 20.3442 27.4024C20.8087 28.6253 21.5095 29.7448 22.4066 30.6969L25.2995 27.971C24.7603 27.3988 24.2834 26.7193 24.0042 25.9843C23.7251 25.2494 23.589 24.5464 23.6124 23.7606C23.6357 22.9747 23.8136 22.2012 24.1359 21.4841C24.2286 21.278 24.5717 20.7441 24.7222 20.5471Z",
    fill: "url(#paint2_linear_2211_8405)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.646 14.3302C25.9156 14.6211 24.2862 15.3712 22.9392 16.5004C22.6146 17.0039 22.1917 17.4212 21.7069 17.7363C21.0406 18.5361 20.491 19.456 20.0939 20.4802C19.842 21.1298 19.6638 21.7898 19.5552 22.451C21.6524 22.4164 23.6652 21.5751 25.1628 20.117C25.2185 20.0588 25.2753 20.0018 25.3332 19.9462C26.0748 19.1803 26.6788 18.2565 27.0884 17.2C27.4543 16.2562 27.6342 15.2861 27.646 14.3302Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2211_8405",
    x1: 12.5808,
    y1: 16.4723,
    x2: 8.47944,
    y2: 16.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800762,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2211_8405",
    x1: 25.5468,
    y1: 14.82,
    x2: 23.4838,
    y2: 11.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2211_8405",
    x1: 22.3138,
    y1: 22.1026,
    x2: 22.7194,
    y2: 26.2722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolWhite);
export default __webpack_public_path__ + "static/media/logo-symbol-white.c9c6860b5dd2dd763e4953c504ffe069.svg";
export { ForwardRef as ReactComponent };